import { render, staticRenderFns } from "./EnableScriptModal.vue?vue&type=template&id=2028b4c0&"
import script from "./EnableScriptModal.vue?vue&type=script&lang=js&"
export * from "./EnableScriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports